const ITEMS = [
  "IT INFRASTRUCTURE",
  "CCTV & SURVEILLANCE",
  "ENTERPRISE NETWORKING",
  "SOFTWARE DEVELOPMENT",
  "CHIP-LEVEL MAINTENANCE",
  "PROCESS AUTOMATION",
  "IT CONSULTANCY",
  "PROJECT MANAGEMENT",
];

export default function Marquee() {
  const row = (
    <>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center gap-8 shrink-0">
          <span className="font-heading text-lg sm:text-xl font-semibold tracking-wide text-slate-600">
            {item}
          </span>
          <span className="w-2 h-2 rotate-45 bg-blue-600/70 shadow-[0_0_12px_rgba(6,182,212,0.8)]" />
        </span>
      ))}
    </>
  );
  return (
    <div className="relative border-y border-slate-200/80 bg-[#F1F5F9] py-5 overflow-hidden" data-testid="capability-marquee">
      <div className="flex gap-8 animate-marquee w-max">
        <div className="flex gap-8">{row}</div>
        <div className="flex gap-8" aria-hidden="true">{row}</div>
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#FFFFFF] to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#FFFFFF] to-transparent pointer-events-none" />
    </div>
  );
}
